import { Box, withStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { distances } from '@setvi/shared/styles';

export const MobileSkeleton = withStyles({
  root: {
    borderRadius: distances.base,
    backgroundColor: 'rgba(23, 23, 37, 0.11) !important',
    flexShrink: 0
  }
})(Skeleton);

export const ListLoader = () => (
  <Box display="flex" flexDirection="column" gridGap="12px">
    {Array.from(new Array(5)).map((_, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <MobileSkeleton key={i} variant="rect" width="100%" height={270} />
    ))}
  </Box>
);
